module.exports = __webpack_public_path__ + "static/process-b05e6d84b3b3349f5a9b2cbb9ad157d2.svg";